import { createRouter, createWebHistory } from 'vue-router'


//Layouts
import UserLayout from '@/layouts/user/UserLayout.vue'
import PublicLayout from '@/layouts/public/PublicLayout.vue'

//Pages
import WelcomeView from '@/views/public/WelcomeView.vue'
import AboutView from '@/views/public/AboutView.vue'
import LoginView from '@/views/auth/LoginView.vue'
import MeView from '@/views/user/MeView.vue'
import MatchesView from '@/views/user/MatchesView.vue'
import ProfileT1View from '@/views/user/ProfileT1View.vue'
import ProfileT2View from '@/views/user/ProfileT2View.vue'
import MatchReportView from '@/views/user/MatchReportView.vue'

import { appStore } from '@/stores/AppStore'
import apiService from '@/services/ApiService'

const routes = [

  //----------------------------Public routes-----------------------------------
  {
    path: '/',
    // name: 'Welcome',
    component: PublicLayout,
    children: [
      { 
        path: '', 
        component: WelcomeView 
      },
      {
        path: '/login',
        component: LoginView,
        beforeEnter: async (to, _from, next) => {
          const store = appStore()
          if (store.isLoggedIn) {
            if (to.query.token) {
              try {
                await apiService.claimToken(to.query.token);
              } catch (err) {
                console.error('Router > claimToken error:', err);
              }
            }
            next('/matches')
          } else {
            next()
          }
        },
      },
      { 
        path: '/about', 
        component: AboutView 
      },
  //     {
  //       path: '/evaluation/:token',
  //       component: StartEvaluationView,        
  //     },
  //     {
  //       path: '/evaluation/:token/questionnaire',
  //       name: 'Questionnaire',
  //       component: AnswerEvaluationView
  //     },
  //     {
  //       path: '/evaluation/thankYou',
  //       component: ThankYou,        
  //     },
    ],

  },
  

  {
    path: '/',
    component: UserLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/matches' },
      { path: 'matches', component: MatchesView },
      { path: 'me', component: MeView },
      { path: 'profile/t1', component: ProfileT1View },
      { path: 'profile/t2', component: ProfileT2View },
      { path: 'matches/:id', component: MatchReportView },
    ]
  },


  // // Client routes
  // {
  //   path: '/client',
  //   component: ClientLayout,
  //   meta: { requiresAuth: true, roles: ['client'] },
  //   children: [
  //     { path: '', component: ClientDashboard },
  //     { path: 'dashboard', component: ClientDashboard },
  //     { path: 'evaluations', component: ClientEvaluations },      
  //   ]
  // },
]

const router = createRouter({
  // process.env.BASE_URL is automatically set by Vue CLI to publicPath from vue.config.js ('/app/').
  // This makes the router strip '/app' from browser URLs before matching routes,
  // so '/app/matches' is seen as '/matches' internally.
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('authToken')
    const isLoggedIn = token !== null

    console.log(`Router > beforeEach > isLoggedIn: ${isLoggedIn} to: ${to} from: ${from}`)
    if (!isLoggedIn) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})


// // utils/routeAuth.js
// export function checkRouteAuth(route, authStore) {
//   // Colectează toate meta-urile din ierarhia de rute
//   const allMeta = route.matched.map(record => record.meta)
  
//   // Verifică dacă oricare din rute necesită autentificare
//   const requiresAuth = allMeta.some(meta => meta.requiresAuth)
  
//   // Colectează toate rolurile permise
//   const allowedRoles = allMeta
//     .filter(meta => meta.roles)
//     .flatMap(meta => meta.roles)
  
//   return {
//     requiresAuth,
//     hasValidRole: !allowedRoles.length || allowedRoles.includes(authStore.user?.role),
//     isAuthenticated: authStore.isAuthenticated
//   }
// }

// // În router guard
// router.beforeEach((to, from, next) => {
//   const authStore = useAuthStore()
//   const { requiresAuth, hasValidRole, isAuthenticated } = checkRouteAuth(to, authStore)
  
//   if (requiresAuth && !isAuthenticated) {
//     next('/login')
//   } else if (requiresAuth && !hasValidRole) {
//     next('/unauthorized')
//   } else {
//     next()
//   }
// })

export default router